import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './JourneySummary.css';

function JourneySummary() {
  const { t } = useTranslation();
  const interests = t('journey.interests', { returnObjects: true });
  const recent = t('journey.recent', { returnObjects: true });

  return (
    <section className="journey-summary" aria-label="Journey 요약">
      <h2 className="journey-title">{t('journey.title')}</h2>
      <div className="journey-body">
        <div className="journey-content">
          <p className="journey-text">
            {t('journey.text1', { name: '김아현' })}
          </p>
          <p className="journey-text">{t('journey.text2')}</p>

          <div className="journey-meta">
            <div>
              <span className="journey-label">{t('journey.interestLabel')}</span>
              <ul className="journey-list">
                {Array.isArray(interests) && interests.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
            <div>
              <span className="journey-label">{t('journey.recentLabel')}</span>
              <ul className="journey-list">
                {Array.isArray(recent) && recent.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          </div>
        </div>
        <Link to="/journey" className="journey-link">{t('journey.linkText')}</Link>
      </div>
    </section>
  );
}

export default JourneySummary;
